import React, { useState, useImperativeHandle } from 'react'
import { View, Text, Image } from 'native-base'
import Modal from 'react-native-modal'
// @ts-ignore - o projeto não tem @types/react-dom (o pacote está instalado)
import { createPortal } from 'react-dom'
import { useTheme } from '../../ThemeProvider'

interface ModalLoaderProps {
  texto?: string
}

// Loader genérico das ações (agendar, entrar, cancelar...).
// Layout novo: cartão branco sobre fundo desfocado, spinner na cor da empresa.
// Modo legado (pwa simples / layout v2 / tema escuro): continua o modal antigo do AG.SIM.

function lerConfig(configEmpresa: any) {
  try {
    if (!configEmpresa) return {}
    return typeof configEmpresa === 'string'
      ? JSON.parse(configEmpresa)
      : configEmpresa
  } catch (error) {
    return {}
  }
}

function ModalLoader({ texto }: ModalLoaderProps, ref: any) {
  const [modalVisible, setModalVisible] = useState<boolean>(false)
  const { primaryColor, configEmpresa } = useTheme()

  function abrirLoader() {
    setModalVisible(true)
  }

  function fecharLoader() {
    setModalVisible(false)
  }

  const noAnimation = {
    from: { opacity: 1, translateY: 0 },
    to: { opacity: 1, translateY: 0 }
  }

  useImperativeHandle(ref, () => ({ abrirLoader, fecharLoader }))

  const config = lerConfig(configEmpresa)
  const utilizaLayoutLegado =
    config.utilizaPwaSimples || config.versaoPWA == 2 || config.utilizaTemaEscuro

  if (!utilizaLayoutLegado) {
    // primaryColor começa como "#fff" no ThemeProvider; sem cor da empresa usa um verde neutro
    const cor =
      primaryColor && primaryColor.toLowerCase() !== '#fff'
        ? primaryColor
        : '#1E7B3C'

    // renderizado direto no <body>: dentro de um ScrollView o "position: fixed"
    // fica preso à área de rolagem e não cobre a tela toda
    const conteudo = (
      <div style={estilos.fundo}>
        <style>{animacoes}</style>
        <div style={estilos.cartao}>
          <div
            className='loader-acao-spinner'
            style={{
              ...estilos.spinner,
              borderColor: 'rgba(0,0,0,0.08)',
              borderBottomColor: cor,
              borderLeftColor: cor
            }}
          />
          <div style={estilos.linhaTexto}>
            <span style={estilos.texto}>
              {(texto ?? 'Carregando').replace(/\.+$/, '')}
            </span>
            <span style={estilos.pontos}>
              <span className='loader-acao-ponto' />
              <span
                className='loader-acao-ponto'
                style={{ animationDelay: '0.2s' }}
              />
              <span
                className='loader-acao-ponto'
                style={{ animationDelay: '0.4s' }}
              />
            </span>
          </div>
          <span style={estilos.subtexto}>Só um instante</span>
        </div>
      </div>
    )

    return typeof document !== 'undefined'
      ? createPortal(conteudo, document.body)
      : conteudo
  }

  // ---------------- Layout legado ----------------
  return (
    <Modal
      isVisible={true}
      animationIn={noAnimation}
      animationOut={noAnimation}
      animationInTiming={0} // Instantâneo
      animationOutTiming={0} // Instantâneo
      style={{
        margin: 0,
        justifyContent: 'center',
        alignItems: 'center'
      }}
    >
      {true && (
        <View
          style={{
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'white',
            width: '50%',
            height: '30%',
            borderRadius: 10,
            padding: 10,
            borderWidth: 1,
            borderColor: 'gray.300'
          }}
        >
          <img
            src={require('../../src/img/loader-agenda2.gif')}
            style={{
              width: 120,
              height: 120
            }}
          />
          <Text fontSize={'2xl'} style={{ color: 'gray.300' }}>
            {texto ?? 'Carregando...'}
          </Text>
        </View>
      )}
    </Modal>
  )
}

const animacoes = `
  .loader-acao-spinner {
    animation: loader-acao-girar 0.9s linear infinite;
  }
  @keyframes loader-acao-girar {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }
  .loader-acao-ponto {
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background: #6f6a62;
    display: inline-block;
    animation: loader-acao-piscar 1.2s infinite ease-in-out;
  }
  @keyframes loader-acao-piscar {
    0%, 80%, 100% { opacity: 0.25; }
    40% { opacity: 1; }
  }
`

const estilos: Record<string, React.CSSProperties> = {
  fundo: {
    position: 'fixed',
    inset: 0,
    zIndex: 10000,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(40, 36, 30, 0.25)',
    backdropFilter: 'blur(6px)',
    WebkitBackdropFilter: 'blur(6px)'
  },
  cartao: {
    minWidth: 170,
    padding: '26px 30px 22px',
    borderRadius: 20,
    backgroundColor: '#fff',
    boxShadow: '0 12px 32px rgba(0,0,0,0.14)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  spinner: {
    width: 42,
    height: 42,
    borderRadius: '50%',
    borderWidth: 3,
    borderStyle: 'solid',
    boxSizing: 'border-box',
    marginBottom: 16
  },
  linhaTexto: {
    display: 'flex',
    alignItems: 'center',
    gap: 6
  },
  texto: {
    fontSize: 15,
    fontWeight: 700,
    color: '#1d1d1d'
  },
  pontos: {
    display: 'inline-flex',
    gap: 3,
    marginTop: 2
  },
  subtexto: {
    fontSize: 12,
    color: '#8a857c',
    marginTop: 6
  }
}

export default React.forwardRef(ModalLoader)
